import styled from "@styled";
import ImageOne from "@data/images/about-us/bge-card.jpg";
import ImageTwo from "@data/images/about-us/about-us-02.jpg";
import ImageThree from "@data/images/about-us/about-us-03.jpg";
export const StyleECard = styled.div`
    background: "#fcfcfc url(${ImageOne})";
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
    width: 580px;
    height: 325px;
    position: relative;
    isolation: isolate;
    padding-top: 30px;
    border-bottom: 14px solid #2dcf9c;
`;
